var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.183 16.2435L6.6977 7.75825C6.40778 7.46834 6.40778 6.9875 6.6977 6.69759C6.98761 6.40768 7.46844 6.40768 7.75836 6.69759L16.2436 15.1829C16.5336 15.4728 16.5336 15.9536 16.2436 16.2435C15.9537 16.5334 15.4729 16.5334 15.183 16.2435Z",
    fill: "#F84459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69752 16.2435C6.40761 15.9536 6.40761 15.4728 6.69752 15.1829L15.1828 6.69759C15.4727 6.40768 15.9536 6.40768 16.2435 6.69759C16.5334 6.9875 16.5334 7.46834 16.2435 7.75825L7.75818 16.2435C7.46827 16.5334 6.98744 16.5334 6.69752 16.2435Z",
    fill: "#F84459"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd3);
export default __webpack_public_path__ + "static/media/add 3.f9c10bf735452d6498374da4be420b7c.svg";
export { ForwardRef as ReactComponent };